export default "__VITE_ASSET__6d78e49a__"